// eslint-disable-next-line import/prefer-default-export
export enum LoanPurposeTypes {
	Purchase = 'Purchase',
	NoCashOutRefinance = 'NoCash-Out Refinance',
	CashOutRefinance = 'Cash-Out Refinance',
}
